import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

export interface SocialMediaPost {
  id: number;
  post_id: string;
  type: 'facebook' | 'instagram' | 'email' | 'tiktok';
  analytics: Record<string, any>;
  content_id: number;
  flyer_id: number;
  integration_id: number;
  created_at: string | null;
  integration: {
    type: string;
    state: string | null;
  };
  flyer_info: {
    id: number;
    flyer_url: string;
    version: number;
  };
  generated_content: {
    id: number;
    content_type: string;
    content_payload: string;
    source_idea_id: number;
    idea_type: string;
    idea_title: string;
    version: number;
    created_at: string;
    content_id: number;
  };
  views: number;
  reach: number;
  engagement: number;
  clicks: number;
}

interface SocialMediaPostsState {
  posts: SocialMediaPost[];
  loading: boolean;
  error: string | null;
}

const initialState: SocialMediaPostsState = {
  posts: [],
  loading: false,
  error: null,
};

const socialMediaPostsSlice = createSlice({
  name: 'socialMediaPosts',
  initialState,
  reducers: {
    fetchSocialMediaPostsRequest: (state, action: PayloadAction<string>) => {
      state.loading = true;
      state.error = null;
    },
    fetchSocialMediaPostsSuccess: (state, action: PayloadAction<SocialMediaPost[]>) => {
      state.loading = false;
      state.posts = action.payload;
      state.error = null;
    },
    fetchSocialMediaPostsFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchSocialMediaPostsRequest,
  fetchSocialMediaPostsSuccess,
  fetchSocialMediaPostsFailure,
} = socialMediaPostsSlice.actions;

export default socialMediaPostsSlice.reducer;
